import { render } from "./ConversionBlock.vue?vue&type=template&id=60d5b456"
import script from "./ConversionBlock.vue?vue&type=script&lang=js"
export * from "./ConversionBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/ConversionBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60d5b456"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60d5b456', __exports__)) {
    api.reload('60d5b456', __exports__)
  }
  
  module.hot.accept("./ConversionBlock.vue?vue&type=template&id=60d5b456", () => {
    api.rerender('60d5b456', render)
  })

}


export default __exports__